import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { SHP_FORMS } from './forms';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ubs-shipping',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./shipping.component.scss']
})
export class ShippingComponent extends BaseComponentConfig implements OnInit {
  componentConfig: ComponentConfig = new ComponentConfig({
    name:"Shipping Application",
    title:"Shipping",
    defaultAction:ActionState.MASTERDETAIL,
    listForm:new OfbizList({
      listFormName:"ListShipmentMethodTypes",
      listFormLocation:"component://kwikstore/widget/ShippingForms.xml",
      listType:"grid",
      columnFields:this.getFields("ListShipmentMethodTypes",SHP_FORMS),
      columnFieldTitles:this.getColumnFieldTitles("ListShipmentMethodTypes",SHP_FORMS),
      appContext:"catalog",
      emptyListMessage:"No shipping methods for this store",
      remoteFormData:{
        formData:{
          formName:"ListShipmentMethodTypes",
          formLocation:"component://kwikstore/widget/ShippingForms.xml",
          listType:"grid",
          viewIndex:1
        },
      }
    }),
    addForm:new OfbizForm({
      formName:"EditShipmentMethodType",
      formLocation:"component://kwikstore/widget/ShippingForms.xml",
      local:true,
      layout:"SingleColumn",
      fields:this.getFields("EditShipmentMethodType",SHP_FORMS),
      targets:this.getTargets("EditShipmentMethodType",SHP_FORMS) || null,
      target:this.getTarget("EditShipmentMethodType",SHP_FORMS) || null,
      appContext:"catalog"
    }),
    findForm:undefined,
    breadCrumbData: {
      displayPrefix:"Shipment Methods for ",
      label:"",
      labelFieldName:"",
      level:1,
      selectedValue:{
        event:"list",
        type:"ListShipmentMethodTypes",
        data:{
          formData:{
            formName:"ListShipmentMethodTypes",
            formLocation:"component://kwikstore/widget/ShippingForms.xml",
            listType:"grid",
            viewIndex:1
          }
        }
        
      }
    }
  })

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    configurationService:ConfigurationService,
    route:ActivatedRoute,
    updateComponentStoreService:UpdateComponentStoreService,
    router:Router) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
   }

  ngOnInit(): void {
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

}
